import { ApolloLink } from '@apollo/client';

import type { Operation } from '#src/contexts/tm/index.ts';

const GRAPHQL_INT_MAX = Math.pow(2, 31) - 1;

type LogOperation = (operation: Operation) => void;

export const createTMApolloLink = (logOperation: LogOperation, path: string) =>
  new ApolloLink((operation, forward) => {
    const start = Date.now();

    return forward(operation).map(response => {
      const context = operation.getContext();

      if (!context.response) {
        return response;
      }

      const { operationName } = operation;
      const timeMs = Math.min(Date.now() - start, GRAPHQL_INT_MAX);

      if (operationName !== 'ReportTelemetry') {
        logOperation({ name: operationName, timeMs, path });
      }

      return response;
    });
  });
